export const AUTH0_SESSION_STORAGE_KEY = 'auth_state' as const
